module.exports = __webpack_public_path__ + "static/img/qalog01.127172f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qalog01.png
// module id = 6DxP
// module chunks = 1